import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import { Figure } from "react-bootstrap";

import logo1 from "./../../assets/images/dot_logo.png";
import logo2 from "./../../assets/images/IMO-2-e1606733903963.png";

import la from "./../../assets/images/left-arrow.svg";
import ra from "./../../assets/images/right-arrow.svg";

function LogoSlider() {
  const nextLogoRef = useRef(null);
  const prevLogoRef = useRef(null);

  const cardData = [
    {
      icon: logo1,
    },
    {
      icon: logo2,
    },
    {
      icon: logo1,
    },
    {
      icon: logo2,
    },
    {
      icon: logo1,
    },
    {
      icon: logo2,
    },
    {
      icon: logo1,
    },
    {
      icon: logo2,
    },
    {
      icon: logo1,
    },
    {
      icon: logo2,
    },
  ];

  return (
    <>
      <div className="trusted-by text-center  mt-5 ">
        <div className="new-title position-relative d-flex justify-content-center mb-5 px-4">
          <div className="">
            {/* Trusted and funded by More{" "} */}
            {/* <span className="text-green-38B652 font-700">900</span> companies */}
          </div>
        </div>

        <div className="logoSlider">
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              nextEl: ".custom-logo-next", // Custom next button
              prevEl: ".custom-logo-prev", // Custom prev button
            }}
            // autoplay={{
            //   delay: 2500,
            //   disableOnInteraction: false,
            // }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              // 768: {
              //   slidesPerView: 2,
              //   spaceBetween: 20,
              // },
              // 1200: {
              //   slidesPerView: 2,
              //   spaceBetween: 30,
              // },
            }}
            // onInit={(swiper) => {
            //   swiper.params.navigation.nextEl = nextLogoRef.current;
            //   swiper.params.navigation.prevEl = prevLogoRef.current;
            //   swiper.navigation.init();
            //   swiper.navigation.update();
            // }}
            className="mySwiper card-list"
          >
            {cardData.map((card, index) => (
              <SwiperSlide key={index} style={{ width: "auto" }}>
                <div className="slide-logo">
                  <Figure>
                    <Figure.Image
                      width={235}
                      height={100}
                      alt="Samsa Logo"
                      src={card.icon}
                    />
                  </Figure>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="logo-navigation d-none">
            {/* Custom Navigation Buttons */}
            <button ref={prevLogoRef} className="custom-logo-prev">
              <img src={la} alt="" className="" />
            </button>
            <button ref={nextLogoRef} className="custom-logo-next">
              <img src={ra} alt="" className="" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default LogoSlider;
